import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    genericGoBackToCardList: 'Gå til kortoversikten',
    genericTryAgain: 'Prøv igjen',
    genericErrorHeader: 'Vi beklager',
    formClose: 'Lukk',
    messageSecondLeft: 'sekunder igjen',
};

export default fallbackDictionary;
